module.exports = __webpack_public_path__ + "static/media/NftFlat1.370274b7.webp";